namespace distill.datasets.views.createWizard1_origin {
    enum DatasetCreationMethod {
        None = "None",
        Manual = "Manual",
        FormScreen = "FormScreen",
        DataSource = "DataSource",
        FileUpload = "FileUpload"
    }

    class InitArgs {
        wizardToken: string = '';
        creationMethod: DatasetCreationMethod = DatasetCreationMethod.None;
        urls!: {
            navigateToStep: string;
        };
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        $(function () {
            bindEvents();
            updateToolbar();
        });
    }

    function getParentButton(selector: string): JQuery<HTMLElement> {
        return $(parent.document).find(selector) as unknown as JQuery<HTMLElement>;
    }

    function bindEvents(): void {
        $(document).on('click', '.wizard-method-card', function () {
            const method = $(this).data('method') as DatasetCreationMethod;
            selectMethod(method);
        });

        getParentButton('#wizardNextBtn').on('click', function () {
            submitForm();
        });
    }

    function selectMethod(method: DatasetCreationMethod): void {
        $('#CreationMethod').val(method);
        $('.wizard-method-card').removeClass('active');
        $(`.wizard-method-card[data-method="${method}"]`).addClass('active');
        updateToolbar();
        
        // Manual skips directly to step 3 on server, but for UX we just submit
        submitForm();
    }

    function updateToolbar(): void {
        const $next = getParentButton('#wizardNextBtn');
        const method = $('#CreationMethod').val();

        if (method && method !== 'None') {
            $next.removeClass('d-none');
        } else {
            $next.addClass('d-none');
        }
    }

    function submitForm(): void {
        ($('form')[0] as HTMLFormElement).submit();
    }
}
